import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';

// Echte Thailand-Bilder
const images = [
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/mczdshyl_1.jpg',
    alt: 'Strand mit Palmen und Bergen'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ic27x5fs_2.jpg',
    alt: 'Buddha-Statue und Tempel'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/di1fvopy_3.jpg',
    alt: 'Fischerboot auf dem Meer'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/hzwvucgn_4.jpg',
    alt: 'Palmenstrand mit Promenade'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/28rnewb9_5.jpg',
    alt: 'Restaurant bei Nacht'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/7c0qi3fi_6.jpg',
    alt: 'Hohe Palmen am Strand'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/sv2ygxa8_7.jpg',
    alt: 'Bunte Straßenszene bei Nacht'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/bozsbm72_8.jpg',
    alt: 'Dramatischer Felsen am Strand'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/wsm88oy4_9.jpg',
    alt: 'Elefanten im Sanctuary'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/3ulszgre_10.jpg',
    alt: 'Street Food bei Nacht'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/h5ycru0s_11.jpg',
    alt: 'Palmen mit Meerblick'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ecbpg6v3_12.jpg',
    alt: 'Schwimmender Markt'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/yslgrhht_13.jpg',
    alt: 'Roter Drachentempel'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/aj4rug9t_14.jpg',
    alt: 'Goldene Buddha-Statue'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/4hyy1gx5_15.jpg',
    alt: 'Sonnenuntergang am Meer'
  }
];

const HeroCarousel = () => {
  const [emblaRef] = useEmblaCarousel(
    { 
      loop: true,
      dragFree: false,
      draggable: false,
      align: 'start'
    },
    [
      AutoScroll({
        playOnInit: true,
        speed: 1,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        direction: 'forward'
      })
    ]
  );

  return (
    <div className="relative group w-full max-w-5xl mx-auto pointer-events-none select-none">
      <div className="overflow-hidden rounded-lg" ref={emblaRef}>
        <div className="flex gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="flex-[0_0_35%] sm:flex-[0_0_30%] md:flex-[0_0_25%] min-w-0"
            >
              <div className="relative aspect-[4/3] overflow-hidden rounded-md shadow-md">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                  loading="lazy"
                  draggable="false"
                />
              </div>
            </div>
          ))}
          {/* Spacer zwischen letztem und erstem Bild */}
          <div className="w-2 flex-shrink-0"></div>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;
